import axios from 'axios'
import {Notify, Toast} from 'vant';

let loading = null

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 50000
})

service.interceptors.response.use(res => {
  loading.clear()
  let dat = res.data
  let code = dat.code || dat.errcode
  let err = dat.msg || dat.errmsg
  switch (code) {
    case -1:
      Notify(err)
      break
    case 0:
      return res.data
    default:
      return res.data
  }
}, error => {
  loading.clear()
  return Promise.reject(error.response)
})

service.interceptors.request.use(config => {
  loading = Toast.loading({duration: 0, forbidClick: true, message: '加载中...'})
  return config
}, err => {
  Promise.reject(err)
})

export default service
